import React, { useState } from 'react';
import Lectorem from 'react-lectorem';

const buttonWrapperStyle = {
  display: 'flex',
  justifyContent: 'center',
};

const buttonStyle = {
  padding: '5px',
  margin: '5px',
  width: '200px',
  color: 'white',
  backgroundColor: '#2269EE',
  borderColor: '#598FF1',
  borderRadius: '3px',
}

const CurrentStory = ({ story }) => {
  const [isTranslationShown, setIsTranslationShown] = useState(true);
  const [isTranslationBelow, setIsTranslationBelow] = useState(true);
  const [isBySentence, setIsBySentence] = useState(true);

  const toggleValue = (flag, setFlag) =>  setFlag(!flag);

  const configuration = { isTranslationShown, isTranslationBelow, isBySentence };

  const disabledButton = {
    color: 'lightgray',
    backgroundColor: 'gray',
    borderColor: 'gray',
  }

  const belowButtonStyle = {
    ...buttonStyle,
    ...(!isTranslationShown && disabledButton),
  };

  return (
    <div>
      <div style={ buttonWrapperStyle }>
          <button style={ buttonStyle } onClick={ () => toggleValue(isBySentence, setIsBySentence) }>
            { isBySentence ? 'Organize by Paragraph' : 'Organize by Sentence' }
          </button>

          <button style={ buttonStyle } onClick={ () => toggleValue(isTranslationShown, setIsTranslationShown)}>
            { isTranslationShown ? 'Hide Translation' : 'ShowTranslation' }
          </button>

          <button style={ belowButtonStyle } onClick={ () => toggleValue(isTranslationBelow, setIsTranslationBelow)}>
            { isTranslationBelow ? 'Translation Beside' : 'Translation Below' }
          </button>
      </div>
      <Lectorem
        data={ story }
        configuration={ configuration }
      />
    </div>
  );
};

export default CurrentStory;


// WEBPACK FOOTER //
// ./src/components/ForStudents/Stories/StoriesList/StoryBox/CurrentStory/CurrentStory.js